import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SwitchComponent } from '../../../../../Components';
import DragDropPicker from '../../Utilities/DragDropPicker/DragDropPicker';
import { getPublicDownloadableLink } from '../../../../../Helper';

const CoverPageForm = ({ localFormChangeHandler, localFormSelection }) => {
  const parentTranslationPath = 'SmartProposal';
  const translationPath = 'CoverPageForm.';
  const { t } = useTranslation(parentTranslationPath);
  const [isFirstLanding, setIsFirstLanding] = useState(true);
  const initializePropertyImages = () => {
    const selectedImageId = localFormSelection?.coverImage?.id;
    const publishedImages = [
      ...(localFormSelection?.data?.propertyPublishedImages || []),
    ];

    publishedImages.forEach((item) => {
      if (item.fileId == selectedImageId) {
        item.isChecked = true;
      } else {
        item.isChecked = false;
      }
    });
    return publishedImages;
  };

  const propertyPublishedImages = useMemo(
    () => initializePropertyImages(),
    [localFormSelection]
  );

  const coverSelectHandler = useCallback(
    (result) => {
      const defaultCoverImage = {
        url: 'https://psi-crm.com/ProposalIcons/defaultCover.jpg',
        id: null,
      };

      const pickedImageId = Array.isArray(result) && result?.[0]?.fileId;
      const coverImageURL = pickedImageId
        ? getPublicDownloadableLink(pickedImageId)
        : null;

      const coverImage = coverImageURL
        ? {
            url: coverImageURL,
            id: pickedImageId,
          }
        : defaultCoverImage;

      localFormChangeHandler('coverImage', coverImage);
    },
    [localFormChangeHandler]
  );

  useEffect(() => {
    if (
      localFormSelection?.data?.propertyPublishedImages?.[0] &&
      isFirstLanding
    ) {
      coverSelectHandler(localFormSelection?.data?.propertyPublishedImages);
      setIsFirstLanding(false);
    }
  }, [localFormSelection]);

  return (
    <>
      <div className='ProposalForm__field_box'>
        <div className='ProposalForm__field_label'>
          <p>Cover Page</p>
        </div>
        <div>
          <DragDropPicker
            onChange={coverSelectHandler}
            itemsList={propertyPublishedImages}
            maxChecked={1}
          />
        </div>
      </div>
      <span className='field_divider'></span>
      {/* <div className="ProposalForm__field_box">
        <div className="ProposalForm__field_label">
          <p>{t(`${translationPath}Contacted-by`)}</p>
        </div>
        <div>
          <RadiosGroupComponent
            idRef="Contacted-by"
            data={Object.values(ContactDetailsType)}
            value={localFormSelection?.data?.contactDetailsType || null}
            labelInput="label"
            valueInput="key"
            themeClass="theme-propx"
            isDisabled
          />
        </div>
      </div>
      <span className="field_divider"></span> */}
      <div className='ProposalForm__field_box'>
        <div className='ProposalForm__field_label'>
          <p>{t(`${translationPath}logo`)}</p>
        </div>
        <div>
          <SwitchComponent
            idRef='showLogoRef'
            themeClass='thick-theme'
            isChecked={localFormSelection?.showLogo || false}
            labelValue={`${localFormSelection?.showLogo ? 'show' : 'hide'}`}
            parentTranslationPath={parentTranslationPath}
            translationPath={''}
            onChangeHandler={(_, isChecked) =>
              localFormChangeHandler('showLogo', isChecked)
            }
          />
        </div>
      </div>
    </>
  );
};

export default CoverPageForm;
